<template>
    <v-container class="pt-5">

      <div class="d-flex flex-row pt-5">
        <img :src="logo" alt="PinPoint Logo">
      </div>

      <!-- ********************************* -->
      <!-- **** Card holds Patient Tree **** -->
      <!-- ********************************* -->
      <div class="pt-6">
        <v-card
          style="height: 20%;"
          flat
          outlined
          tile
        >

          <v-card-title style="background-color: #e0e0e0;">
            {{cardTitle}}
          </v-card-title>

          <!-- ************************************************** -->
          <!-- **** Bind patientData To node prop            **** -->
          <!-- **** and  bind parent_id to parent_id prop    **** -->
          <!-- **** to be used in DisplayPatientTree.vue     **** -->
          <!-- ************************************************** -->
          <DisplayPTree
            v-if="root_id"
            :node="patientData"
            :root_id = "root_id"
            class="pl-5 pt-5 pb-4"
          />

        </v-card>
      </div>

    </v-container>
 </template>


<script>
import PinPointLogo from "../../../assets/PinPointLogo.png"
import DisplayPTree from '../PTreeComponents/DisplayPtree'
import { mapGetters } from 'vuex'
export default {
  name: 'home',
  components: {
    DisplayPTree
  },
  data: function () {
    return {
        logo: PinPointLogo,
        cardTitle: 'Patient Records',
        theData: {},
    }
  },
  beforeMount() {
    // Check Route Name
    if(this.$route.name === 'pTree') {
      this.$store.dispatch('loadPatientData', this.$route.params.id)

      //this.$store.dispatch('viewGetWholeRecord', this.$route.params.id)
    }
  },
  computed: {
    ...mapGetters({
      patientData: 'getPatientData',
      patientDataz: 'getPatientDataMap',
      root_id: 'getParentId',
    }),
    setData() {
      this.theData = this.patientData;
      return this.theData
    }
  },
}
</script>
